'use client';

import React from 'react';

type SearchGroupProps = {
  heading: string;
  children: React.ReactNode;
};

export const GROUP_SELECTOR = '[data-group]';
export const GROUP_HEADING_SELECTOR = '[data-group-heading]';

export const SearchGroup = React.forwardRef<
  React.ElementRef<'ul'>,
  SearchGroupProps
>(function SearchGroup({ heading, children }, ref) {
  return (
    <div className="px-2.5 py-4" data-group="">
      <p
        className="px-2 text-sm font-medium text-tertiary"
        data-group-heading=""
      >
        {heading}
      </p>
      <ul ref={ref}>{children}</ul>
    </div>
  );
});
